const headRowsManagementEquip = {
  equipmentModelName: 'Equipamento',
  equipmentGroupName: 'Grupo',
  placeName: 'Local',
  referenceName: 'Ponto de Referência',
  description: 'Descrição',
  company: 'Empresas Terceiras',
  createdAt: 'Criado em',
};

export default headRowsManagementEquip;
